/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

export const WizardImportPersonalDataStyled = styled.div.attrs({
    className: 'wizard-import-personal-data',
})`
    margin-top: 32px;

    .wizard-import-personal-data__title {
        ${fonts.textMainBold}
        margin-bottom: 24px;
    }

    .wizard-import-personal-data__warning {
        max-width: 700px;
        margin-bottom: 24px;
    }

    .wizard-import-personal-data__info {
        margin-bottom: 24px;
    }

    .wizard-import-personal-data__button {
        margin-top: 24px;
    }

    .wizard-import-personal-data__attach-file {
        display: flex;
        align-items: center;
        margin-top: 16px;
    }

    .wizard-import-personal-data__attach-file-name {
        margin-left: 10px;
        ${fonts.textMainBold}
    }

    .wizard-import-personal-data__attach-file-error {
        margin-top: 16px;
        color: ${colors.textColorDanger};
    }

    .wizard-import-personal-data__export-errors {
        display: flex;
        justify-content: space-between;
    }

    .wizard-import-personal-data__table {
        margin-top: 24px;
    }
`;
